import { HttpParams } from '@angular/common/http';
import { Service } from '@angular/core';
import { map, Observable } from 'rxjs';
import { KalaApiResponse } from '../../models/kala-api.model';
import { BaseService } from '../../services/base.service';
import { KALA_MARKET } from './market-data.constants';
import { parseMarketViewList, parseSymbolInfoList } from './market-data.utils';
import { MarketViewSnapshot, SymbolInfo } from './market-data.model';

@Service()
export class MarketDataService extends BaseService {
	private readonly marketParams = new HttpParams().set('market', KALA_MARKET);

	/** Errors when the answer is unsuccessful or any row is malformed — see `parseSymbolInfoList`. */
	getSymbolInfo(): Observable<SymbolInfo[]> {
		return this.http
			.get<KalaApiResponse<unknown>>(`${this.marketDataApiPath}/marketview/symbolinfo`, {
				params: this.marketParams
			})
			.pipe(
				map(response => {
					const list = response?.isSuccessful ? parseSymbolInfoList(response.data) : null;
					if (!list) {
						throw new Error('symbolinfo: malformed response');
					}
					return list;
				})
			);
	}

	getMarketView(): Observable<MarketViewSnapshot[]> {
		return this.http
			.get<KalaApiResponse<unknown>>(`${this.marketDataApiPath}/market-view`, { params: this.marketParams })
			.pipe(
				map(response => {
					if (!response?.isSuccessful) {
						throw new Error('market-view: unsuccessful response');
					}
					return parseMarketViewList(response.data);
				})
			);
	}
}
